import {
  CountryInterface,
  GroupsCatalog,
  OrderItemStatusInterface,
  OrderStatusInterface,
  PlantOperativeModes,
  RootCatalogInterface,
  SubGroupCatalog,
} from '@core/interfaces';
import { PlantListInterface } from '../pages/record/interfaces';
import { ICompanyModel } from '@core/models/admin/company/company.model';
import { IUserModel } from '@core/models/shared/user.model';
import { IUserRoles } from '@core/models/admin/roles/roles.model';
import { StripePrice } from '@core/models/admin-manager/stripePrice';
import { UrbanArea, Region } from '@shared/interfaces/certify/urban-area';
import { PaymentTerms } from '../pages/invoice/pre-invoice/order-information/models/payment-terms.model';
import { salesChannel } from '../pages/orders/interfaces/salesChannel.interface';
import { iItemsTypes } from '../pages/orders/order-taking/components/new-order/models/iItemsTypes.model';

import { otcCatalog } from '../pages/orders/interfaces/oneTimeCustomer.interface';
import { newOrderSelect } from '../pages/orders/interfaces/newOrderSelect.interface';
import { AditionalService } from '../pages/orders/interfaces/additionalService.interface';
import { IdbCountryReceiverEntry, IdbOtDefaultDataEntry } from './idb.types';
import { IMenuByUserResponse } from '../store/menu-by-user/menu-by-user.model';
import { IApplication } from '@core/models/admin/application/application.model';
import { RegionModel } from '../pages/profiler/interfaces/Tenants';

export enum IdbCatalogName {
  Country = 'country',
  OrderStatus = 'orderStatus',
  OrderItemStatus = 'orderItemStatus',
  Plants = 'plants',
  PlantsFull = 'plantsFull',
  Menus = 'menus',
  Applications = 'applications',
  CompanyRegions = 'companyRegions',
  EquipmentCategories = 'equipmentCategories',
  VehicleTypes = 'vehicleTypes',
  Units = 'units',
  GpsProviders = 'gpsProviders',
  VehicleStatus = 'vehicleStatus',
  Groups = 'groups',
  SubGroups = 'subGroups',
  OperativeModes = 'operativeModes',
  CompanyInfo = 'companyInfo',
  AccountInfo = 'accountInfo',
  UserRoles = 'userRoles',
  StripePrices = 'stripePrices',
  Areas = 'areas',
  Regions = 'regions',
}

export enum IdbOtCatalogName {
  PaymentTerms = 'otPaymentTerms',
  SalesChannels = 'otSalesChannels',
  OrderItemTypes = 'otOrderItemTypes',
  TaxClasses = 'otTaxClasses',
  CashPaymentTypes = 'otCashPaymentTypes',
  DeliveryMethods = 'otDeliveryMethods',
  CountriesReceivers = 'otCountriesReceivers',
  OrderStatuses = 'otOrderStatuses',
  OrderDefaultData = 'otOrderDefaultData',
  AdditionalServices = 'otAdditionalServices',
}

export type IdbCatalogTypeMap = {
  [IdbCatalogName.Country]: CountryInterface[];
  [IdbCatalogName.OrderStatus]: OrderStatusInterface[];
  [IdbCatalogName.OrderItemStatus]: OrderItemStatusInterface[];
  [IdbCatalogName.Plants]: PlantListInterface[];
  [IdbCatalogName.PlantsFull]: PlantListInterface[];
  [IdbCatalogName.Menus]: IMenuByUserResponse | null;
  [IdbCatalogName.Applications]: IApplication[] | null;
  [IdbCatalogName.CompanyRegions]: RegionModel[] | null;
  [IdbCatalogName.EquipmentCategories]: RootCatalogInterface[];
  [IdbCatalogName.VehicleTypes]: RootCatalogInterface[];
  [IdbCatalogName.Units]: RootCatalogInterface[];
  [IdbCatalogName.GpsProviders]: RootCatalogInterface[];
  [IdbCatalogName.VehicleStatus]: RootCatalogInterface[];
  [IdbCatalogName.Groups]: GroupsCatalog[];
  [IdbCatalogName.SubGroups]: SubGroupCatalog[];
  [IdbCatalogName.OperativeModes]: PlantOperativeModes[];
  [IdbCatalogName.CompanyInfo]: ICompanyModel;
  [IdbCatalogName.AccountInfo]: IUserModel;
  [IdbCatalogName.UserRoles]: IUserRoles[];
  [IdbCatalogName.StripePrices]: StripePrice[];
  [IdbCatalogName.Areas]: UrbanArea[];
  [IdbCatalogName.Regions]: Region[];
};

export type IdbOtCatalogTypeMap = {
  [IdbOtCatalogName.PaymentTerms]: PaymentTerms[];
  [IdbOtCatalogName.SalesChannels]: salesChannel[];
  [IdbOtCatalogName.OrderItemTypes]: iItemsTypes[];
  [IdbOtCatalogName.TaxClasses]: otcCatalog[];
  [IdbOtCatalogName.CashPaymentTypes]: otcCatalog[];
  [IdbOtCatalogName.DeliveryMethods]: newOrderSelect[];
  [IdbOtCatalogName.CountriesReceivers]: IdbCountryReceiverEntry[];
  [IdbOtCatalogName.OrderStatuses]: newOrderSelect[];
  [IdbOtCatalogName.OrderDefaultData]: IdbOtDefaultDataEntry;
  [IdbOtCatalogName.AdditionalServices]: AditionalService[];
};
